import { useState } from 'react'

export function useLocalStorageBoolean({
  key,
  defaultValue = false,
}: {
  key: string
  defaultValue?: boolean
}) {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key)

    return storedValue === null ? defaultValue : storedValue === 'true'
  })

  const setValueAndPersist = (
    action: boolean | ((prev: boolean) => boolean),
  ) => {
    setValue((prev) => {
      const next = typeof action === 'function' ? action(prev) : action
      localStorage.setItem(key, String(next))

      return next
    })
  }

  return {
    value,
    setValue: setValueAndPersist,
  }
}
